import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';
import * as _ from 'lodash';
import { User } from '@common/models/User';
import { CommonService } from '@common/services/common.service';
import { CqrsService } from '@common/services/cqrs.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class CanViewGuard implements CanActivate, CanActivateChild {
    private currentUser: User;
    protected cqrs: CqrsService;
    protected toastrService: ToastrService;
    protected translateService: TranslateService;

    constructor(
        private userService: UserService, 
        private router: Router,
        protected common: CommonService) 
{
        this.cqrs = common.cqrs;
        this.toastrService = common.toastrService;
        this.translateService = common.translateService;
        userService.currentUserSubject.subscribe((user) => this.currentUser = user);
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        console.log(route)

        const id = route.paramMap.get('id');

        const isVesselVisit = state.url.includes('/vessel-visit/');
        const isVesselVisitDocument = state.url.includes('/vessel-visit-document/');

        var result = true;

        if (isVesselVisitDocument) {        
            const model = await this.cqrs.query('VesselVisitDocument', { id });   

            // some checks are made on backend to see if user can edit vessel visit document, if he can't null is returned
            if(model === undefined || model === null){
                this.toastrService.error(this.translateService.instant('User does not have neccessary permission to view vessel visit documents'));
                result = false;
            }
        }else if(isVesselVisit) {
            const model = await this.cqrs.query('VesselVisit', { id });

            // some checks are made on backend to see if user can edit vessel visit, if he can't null is returned
            if(model === undefined || model === null){
                this.toastrService.error(this.translateService.instant('User does not have neccessary permission to view vessel visit'));
                result = false;
            }
        }

        console.log(`canviewguard, result=${result}`);

        return result;
    }    

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(childRoute, state);
    }       
}
